"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Autocomplete_1 = require("@material-ui/lab/Autocomplete");
var GenericInput_1 = require("../genericInput/GenericInput");
var GenericInputStyles_1 = require("../genericInput/GenericInputStyles");
var AutocompleteInput = function (_a) {
    var formData = _a.formData;
    var label = formData.label, required = formData.required, id = formData.id, value = formData.value, options = formData.options, onChange = formData.onChange, placeholder = formData.placeholder;
    var styles = GenericInputStyles_1.default();
    var dealers = options.dependencies;
    var filterOptions = Autocomplete_1.createFilterOptions({
        matchFrom: 'any',
        limit: 50,
    });
    function handleOnChange(option) {
        var _a;
        onChange((_a = option) === null || _a === void 0 ? void 0 : _a.value);
        formData.formContext.setAvailableDealers([dealers.dealer[option.value]]);
    }
    return (<Autocomplete_1.default filterOptions={filterOptions} noOptionsText={options.invalidOption} onChange={function (_, option) { return handleOnChange(option); }} classes={{
        input: styles.input,
        noOptions: styles.noOptions,
    }} id={id} options={options.enumOptions} getOptionLabel={function (option) { return option.label; }} data-test={"autocomplete_input:" + id} renderInput={function (params) { return (<GenericInput_1.default label={label} required={required} id={id} value={value} params={params} placeholder={placeholder} tooltip={options.tooltip}/>); }}/>);
};
exports.default = AutocompleteInput;
